<app-programtitle title="Login via User name and pasword"></app-programtitle>

<p> Write a program which will accept a user name and password from user and display whether the user is an authorised user or not.</p>

<p> The only valid username and password is : python/awesome</p>

<app-editor code="{{program}}"> </app-editor>

